module.exports = __webpack_public_path__ + "img/weixin-checked.138667cd.png";